

















import { defineClassComponent } from '@/hooks'
import { formatDate } from 'vtils/date'
import { ref } from '@vue/composition-api'

export default defineClassComponent<{
  value: Date
}>(
  {
    inheritAttrs: false,
    props: ['value'],
  },
  ({ props, ctx }) =>
    class {
      visible = ref(false)

      initialDate = ref(props.value)

      format = (template: string) => {
        return formatDate(props.value, template)
      }

      handleTriggerClick = () => {
        this.visible.value = !this.visible.value
      }

      handleDateCancel = () => {
        this.visible.value = false
      }

      handleDateConfirm = (date: Date) => {
        ctx.$emit('input', date)
        this.visible.value = false
      }
    },
)
